module.exports = __webpack_public_path__ + "img/boleto.e26be171.svg";